import { style, styleVariants } from '@vanilla-extract/css'
import { vars } from '~/styles/theme.css'

export const wrapper = style({
  background: vars.color.darkLighter,
  color: vars.color.white,
  padding: '11px 18px',
  fontSize: vars.font.body.size,
  fontWeight: vars.font.body.weight,
  borderRadius: vars.blocks.radius,
  width: 'max-content',
  maxWidth: 300,
  whiteSpace: 'pre-line',
  filter: 'drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.15))',
  zIndex: 9999
})

export const arrowBase = style({
  position: 'absolute',
  background: vars.color.darkLighter,
  width: 12,
  height: 8,
  clipPath: 'polygon(0 0, 100% 0, 50% 100%)',
  transform: 'rotate(var(--arrow-rotation, 0deg))'
})

export const arrowSide = styleVariants({
  top: {
    bottom: -7,
    vars: {
      '--arrow-rotation': '0deg'
    }
  },
  bottom: {
    top: -7,
    vars: {
      '--arrow-rotation': '180deg'
    }
  },
  left: {
    right: -7,
    vars: {
      '--arrow-rotation': '270deg'
    }
  },
  right: {
    left: -7,
    vars: {
      '--arrow-rotation': '90deg'
    }
  }
})
